"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditTransactionType = exports.CreditTransactionStatus = void 0;
var CreditTransactionStatus;
(function (CreditTransactionStatus) {
    CreditTransactionStatus["PENDING"] = "pending";
    CreditTransactionStatus["HELD_FOR_AUCTION"] = "held-for-auction";
    CreditTransactionStatus["COMPLETED"] = "completed";
    CreditTransactionStatus["EXPIRED"] = "expired";
    CreditTransactionStatus["LOCKED"] = "locked";
    CreditTransactionStatus["FAILED"] = "failed";
    CreditTransactionStatus["CANCELLED"] = "cancelled";
})(CreditTransactionStatus || (exports.CreditTransactionStatus = CreditTransactionStatus = {}));
var CreditTransactionType;
(function (CreditTransactionType) {
    CreditTransactionType["REWARD"] = "reward";
    CreditTransactionType["REWARD_GAMEWEEK"] = "reward_gameweek";
    CreditTransactionType["PURCHASE"] = "purchase";
    CreditTransactionType["REFERRAL"] = "referral";
    CreditTransactionType["WELCOME"] = "welcome";
    CreditTransactionType["REFUND"] = "refund";
    CreditTransactionType["ADMIN"] = "admin";
})(CreditTransactionType || (exports.CreditTransactionType = CreditTransactionType = {}));
